<template>
  <div id="cfixed" class="cfixed">
    <!-- <div class="fixContainer">
      <i class="fa fa-weixin"></i>
      <img class="linkImg" src="../../static/img/aecworks-ewm.png" alt="">
    </div>
    <div class="fixContainer">
      <i class="fa fa-qq"></i>
      <img class="linkImg" src="../../static/img/obv-developer.jpg" alt="">
    </div> -->
    <div class="fixContainer" v-show="backBtn" @click="backToTop()">
      <i class="fa fa-angle-up" style="font-size: 40px"></i>
    </div>
</div>
</template>

<script>
export default {
    name: 'cfixed',
    data() {
        return {
            backBtn: false,
        };
    },
    methods: {
        backToTop() {
            if (document.documentElement.scrollTop) {
                document.documentElement.scrollTop = 0;
            } else if (document.body.scrollTop) {
                document.body.scrollTop = 0;
            }
        },
    },
    mounted() {
    // 页面滚动事件
        const _self = this;
        window.onscroll = function () {
            const t = document.documentElement.scrollTop || document.body.scrollTop;
            if (t > 0) {
                _self.backBtn = true;
            } else {
                _self.backBtn = false;
            }
        };
    },
};
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
  @import '~common/stylus/variable'
  @import '~common/stylus/mixin'
  .cfixed
    position fixed
    right 0px
    top 50%
    z-index: 99
    .fixContainer
      dom_center()
      width 45px
      height 45px
      font-size 22px
      color #16C7FF
      background-color $background-white
      border 1px solid #16C7FF
      &:hover
        i
          color:#0e73af;
        .linkImg
          transform: scale(1);
          opacity: 1;
    .fixContainer:nth-of-type(2)
      border-top 0px
    .fixContainer:nth-of-type(3)
      border-top 0px
    .linkImg
      position: absolute;
      z-index: 9;
      right: 55px;
      width: 7.5rem;
      max-width: none;
      height: 7.5rem;
      transform: scale(0);
      transform-origin: right center;
      opacity: 1;
      border: .3125rem solid #0e73af;
      border-radius: .25rem;
      -webkit-transition: all .4s ease-in-out;
      -o-transition: all .4s ease-in-out;
      transition: all .4s ease-in-out;
</style>



// WEBPACK FOOTER //
// src/components/cfixed.vue